import {appStyles} from "../../styles";
import {IconButton, Grid, Hidden, withStyles} from "@material-ui/core";
import {Cancel, Delete, Edit} from "@material-ui/icons";
import React from "react";


const HoverControls = withStyles(appStyles)((props) => {
    const {classes, onCancel, onEdit, onDelete, blocked, content} = props;
    return (
        <>
            <Grid container>
            <Grid item className={blocked ? "no-hide" : "will-hide"}>
                {content}
            </Grid>
            <Hidden xsUp={blocked}>
                <Grid item className={`hidden-control`}>
                    <Hidden xsUp={!onCancel}>
                        <IconButton aria-label="cancel" onClick={onCancel} className={classes.noPadding}>
                            <Cancel/>
                        </IconButton>
                    </Hidden>
                    <Hidden xsUp={!onEdit}>
                        <IconButton aria-label="edit" onClick={onEdit} className={classes.noPadding}>
                            <Edit/>
                        </IconButton>
                    </Hidden>
                    <Hidden xsUp={!onDelete}>
                        <IconButton aria-label="delete" onClick={onDelete} className={classes.noPadding}>
                            <Delete/>
                        </IconButton>
                    </Hidden>
                </Grid>
            </Hidden>
            </Grid>
        </>
    )
})

export default HoverControls;
